import script from "./PasesReservados.vue?vue&type=script&setup=true&lang=js"
export * from "./PasesReservados.vue?vue&type=script&setup=true&lang=js"

import "./PasesReservados.vue?vue&type=style&index=0&id=9ffa9c18&lang=css"

const __exports__ = script;

export default __exports__